(function () {
  function money(cents) {
    var val = Math.round(cents / 100);
    return '₹' + val.toLocaleString('en-IN');
  }

  function init() {
    var pdp = document.getElementById('pdp');
    if (!pdp) return;

    var jsonEl = pdp.parentElement.querySelector('script[id^="ProductJson-"]') || document.querySelector('script[id^="ProductJson-"]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    /* ---- Gallery ---- */
    var mainImgs = document.querySelectorAll('.pdp-main-img-el');
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var dots = document.querySelectorAll('.pdp-img-dot');

    function showMedia(index) {
      mainImgs.forEach(function (img) {
        var match = img.dataset.mediaIndex === String(index);
        img.style.display = match ? '' : 'none';
        img.classList.toggle('active', match);
      });
      thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.mediaIndex === String(index)); });
      dots.forEach(function (d) { d.classList.toggle('active', d.dataset.mediaIndex === String(index)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaIndex); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { showMedia(d.dataset.mediaIndex); }); });

    /* ---- Qty stepper ---- */
    var qtyEl = document.getElementById('qty-num');
    var addBtn = document.getElementById('pdp-add');
    var mobileAddBtn = document.getElementById('pdp-mobile-add');

    function syncQty() {
      var q = qtyEl.value;
      if (addBtn) addBtn.dataset.qty = q;
      if (mobileAddBtn) mobileAddBtn.dataset.qty = q;
    }
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');
    if (qtyMinus) qtyMinus.addEventListener('click', function () { qtyEl.value = Math.max(1, parseInt(qtyEl.value, 10) - 1); syncQty(); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { qtyEl.value = Math.min(99, parseInt(qtyEl.value, 10) + 1); syncQty(); });

    /* ---- Bulk quantity tiers (informational estimate, real checkout price is the product's Shopify price) ---- */
    var tiersWrap = document.getElementById('pdp-tiers');
    var tierTotalEl = document.getElementById('pdp-tier-total');
    function updateTierTotal() {
      if (!tiersWrap || !tierTotalEl) return;
      var active = tiersWrap.querySelector('.pdp-tier.active');
      if (!active) return;
      var price = parseInt(active.dataset.price, 10) || 0;
      var qty = parseInt(qtyEl.value, 10) || 1;
      tierTotalEl.textContent = '₹' + (price * qty).toLocaleString('en-IN') + ' for ' + qty + ' pcs';
    }
    if (tiersWrap) {
      tiersWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-tier');
        if (!btn) return;
        tiersWrap.querySelectorAll('.pdp-tier').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        var min = parseInt(btn.dataset.qtyMin, 10);
        if (min && (parseInt(qtyEl.value, 10) || 0) < min) { qtyEl.value = min; syncQty(); }
        updateTierTotal();
      });
      qtyEl.addEventListener('input', updateTierTotal);
      if (qtyMinus) qtyMinus.addEventListener('click', updateTierTotal);
      if (qtyPlus) qtyPlus.addEventListener('click', updateTierTotal);
      updateTierTotal();
    }

    /* ---- Option / variant matching ---- */
    var optionGroups = document.querySelectorAll('.pdp-opt-group');
    function currentSelection() {
      var sel = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.pdp-opt-btn.active');
        sel.push(active ? active.dataset.value : null);
      });
      return sel;
    }
    function findVariant(selection) {
      return product.variants.find(function (v) {
        return selection.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function applyVariant(variant) {
      if (!variant) return;
      var priceEl = document.getElementById('pdp-price');
      var mrpEl = document.getElementById('pdp-mrp');
      var saveEl = document.getElementById('pdp-save');
      var stockEl = document.getElementById('pdp-stock-label');
      var mobilePriceEl = document.getElementById('pdp-mobile-price');

      if (priceEl) priceEl.textContent = money(variant.price);
      if (mobilePriceEl) mobilePriceEl.textContent = money(variant.price);
      var savePct = 0;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        savePct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      }
      if (mrpEl && saveEl) {
        if (savePct > 0) {
          mrpEl.textContent = money(variant.compare_at_price);
          saveEl.textContent = 'Save ' + savePct + '%';
          mrpEl.style.display = '';
          saveEl.style.display = '';
        } else {
          mrpEl.style.display = 'none';
          saveEl.style.display = 'none';
        }
      }
      if (stockEl) stockEl.textContent = variant.available ? 'In Stock' : 'Sold Out';

      [addBtn, mobileAddBtn].forEach(function (btn) {
        if (!btn) return;
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        btn.style.opacity = variant.available ? '' : '.5';
        btn.style.cursor = variant.available ? '' : 'not-allowed';
      });
      if (addBtn) {
        var svg = addBtn.querySelector('svg');
        addBtn.textContent = variant.available ? 'Add to Order' : 'Sold Out';
        if (svg) addBtn.prepend(svg);
      }
      if (mobileAddBtn) mobileAddBtn.textContent = variant.available ? 'Add to Order' : 'Sold Out';

      if (variant.featured_media) {
        var idx = product.media.findIndex(function (m) { return m.id === variant.featured_media.id; });
        if (idx > -1) showMedia(idx);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-opt-btn');
        if (!btn) return;
        group.querySelectorAll('.pdp-opt-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var label = group.querySelector('.pdp-opt-selected');
        if (label) label.textContent = btn.dataset.value;
        var variant = findVariant(currentSelection());
        if (variant) applyVariant(variant);
      });
    });

    syncQty();

    /* ---- Accordion ---- */
    document.querySelectorAll('.pdp-acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pdp-acc-item');
        var open = item.classList.contains('open');
        document.querySelectorAll('.pdp-acc-item').forEach(function (i) { i.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
